export default "__VITE_ASSET__DyFFgHIE__"